export const DEFAULT_LOCALE = 'en-US';
export const SUPPORTED_LOCALES = ['en-US', 'da-DK', 'fr-FR', 'es-ES', 'de-DE', 'pt-BR'] as const;
export type Locales = (typeof SUPPORTED_LOCALES)[number];
export const LOCALE_MAP = {
  'en-US': 'en',
  'da-DK': 'da',
  'fr-FR': 'fr',
  'es-ES': 'es',
  'de-DE': 'de',
  'pt-BR': 'pt',
};

export const LANGUAGES = [
  {
    value: 'en-US',
    label: 'English (US)',
  },
  {
    value: 'en-GB',
    label: 'English (UK)',
  },
  {
    value: 'da-DK',
    label: 'Danish',
  },
  {
    value: 'fr-FR',
    label: 'French',
  },
  {
    value: 'es-ES',
    label: 'Spanish',
  },
  {
    value: 'de-DE',
    label: 'German',
  },
  {
    value: 'pt-BR',
    label: 'Portuguese (Brazil)',
  },
];

export function mapLocale(locale: string | null | undefined) {
  if (!locale) return 'en';

  return (LOCALE_MAP as { [key: string]: string })[locale] ?? 'en';
}

export function getLocale(): Locales {
  const appLang = localStorage.getItem('v1:presist-duplicati:locale') || DEFAULT_LOCALE;
  const locale = SUPPORTED_LOCALES.find((x) => x === appLang) ?? DEFAULT_LOCALE;
  return locale;
}
